var dependencies = ['ngMaterial', 'ui.router'];
var defaultName = angular.module('comcast.common.notification', dependencies).name;
export { defaultName as default, dependencies };